import { useShallow } from "zustand/react/shallow";
import { AUTO_ENABLED_FLAGS, FEATURE_FLAGS } from "@/lib/feature-flags";
import { useFeatureFlagsStore } from "@/stores/feature-flags-store";

const resolveFlag = (flags: Record<string, boolean>, key: string): boolean => {
  const stored = flags[key];
  if (stored !== undefined) return stored;
  if (AUTO_ENABLED_FLAGS.has(key)) return true;
  return FEATURE_FLAGS.find((f) => f.key === key)?.defaultValue ?? false;
};

export const useFeatureFlag = (keys: string[]): boolean[] =>
  useFeatureFlagsStore(
    useShallow((s) => keys.map((k) => resolveFlag(s.flags, k))),
  );

export const useSetFeatureFlag = () => useFeatureFlagsStore((s) => s.setFlag);
